"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@iconify/react");
var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));
var _CurrentTime = _interopRequireDefault(require("./CurrentTime"));
var _Duration = _interopRequireDefault(require("./Duration"));
var _VolumeBar = _interopRequireDefault(require("./VolumeBar"));
var _constants = require("./constants");
exports.RHAP_UI = _constants.RHAP_UI;
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var H5AudioPlayer = /*#__PURE__*/function (_Component) {
  function H5AudioPlayer() {
    var _this;
    _classCallCheck(this, H5AudioPlayer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, H5AudioPlayer, [].concat(args));
    _this.audio = function () {
      return /*#__PURE__*/(0, _react.createRef)();
    }();
    _this.progressBar = function () {
      return /*#__PURE__*/(0, _react.createRef)();
    }();
    _this.container = function () {
      return /*#__PURE__*/(0, _react.createRef)();
    }();
    _this.lastVolume = function (_this$props$volume) {
      return (_this$props$volume = _this.props.volume) !== null && _this$props$volume !== void 0 ? _this$props$volume : 1;
    }();
    _this.togglePlay = function (e) {
      e.stopPropagation();
      var audio = _this.audio.current;
      if ((audio.paused || audio.ended) && audio.src) {
        _this.playAudioPromise();
      } else if (!audio.paused) {
        audio.pause();
      }
    };
    _this.playAudioPromise = function () {
      if (_this.audio.current.error) {
        _this.audio.current.load();
      }
      var playPromise = _this.audio.current.play();
      if (playPromise) {
        playPromise.then(null).catch(function (err) {
          var onPlayError = _this.props.onPlayError;
          onPlayError && onPlayError(new Error(err));
        });
      } else {
        _this.forceUpdate();
      }
    };
    _this.isPlaying = function () {
      var audio = _this.audio.current;
      if (!audio) return false;
      return !audio.paused && !audio.ended;
    };
    _this.handlePlay = function (e) {
      _this.forceUpdate();
      _this.props.onPlay && _this.props.onPlay(e);
    };
    _this.handlePause = function (e) {
      if (!_this.audio) return;
      _this.forceUpdate();
      _this.props.onPause && _this.props.onPause(e);
    };
    _this.handleEnded = function (e) {
      if (!_this.audio) return;
      _this.forceUpdate();
      _this.props.onEnded && _this.props.onEnded(e);
    };
    _this.handleAbort = function (e) {
      _this.props.onAbort && _this.props.onAbort(e);
    };
    _this.handleClickVolumeButton = function () {
      var audio = _this.audio.current;
      if (audio.volume > 0) {
        _this.lastVolume = audio.volume;
        audio.volume = 0;
      } else {
        audio.volume = _this.lastVolume;
      }
    };
    _this.handleMuteChange = function () {
      _this.forceUpdate();
    };
    _this.handleClickLoopButton = function () {
      _this.audio.current.loop = !_this.audio.current.loop;
      _this.forceUpdate();
    };
    _this.handleClickRewind = function () {
      var _this$props = _this.props,
        progressJumpSteps = _this$props.progressJumpSteps,
        progressJumpStep = _this$props.progressJumpStep;
      var jumpStep = progressJumpSteps.backward || progressJumpStep;
      _this.setJumpTime(-jumpStep);
    };
    _this.handleClickForward = function () {
      var _this$props2 = _this.props,
        progressJumpSteps = _this$props2.progressJumpSteps,
        progressJumpStep = _this$props2.progressJumpStep;
      var jumpStep = progressJumpSteps.forward || progressJumpStep;
      _this.setJumpTime(jumpStep);
    };
    _this.setJumpTime = function (time) {
      var audio = _this.audio.current;
      var duration = audio.duration,
        prevTime = audio.currentTime;
      if (audio.readyState === audio.HAVE_NOTHING || audio.readyState === audio.HAVE_METADATA || !isFinite(duration) || !isFinite(prevTime)) {
        try {
          audio.load();
        } catch (err) {
          return _this.props.onChangeCurrentTimeError && _this.props.onChangeCurrentTimeError(err);
        }
      }
      var currentTime = prevTime + time / 1000;
      if (currentTime < 0) {
        audio.currentTime = 0;
        currentTime = 0;
      } else if (currentTime > duration) {
        audio.currentTime = duration;
        currentTime = duration;
      } else {
        audio.currentTime = currentTime;
      }
    };
    _this.setJumpVolume = function (volume) {
      var newVolume = _this.audio.current.volume + volume;
      if (newVolume < 0) newVolume = 0;else if (newVolume > 1) newVolume = 1;
      _this.audio.current.volume = newVolume;
    };
    _this.handleKeyDown = function (e) {
      var _this$props$hasDefaul;
      if ((_this$props$hasDefaul = _this.props.hasDefaultKeyBindings) !== null && _this$props$hasDefaul !== void 0 ? _this$props$hasDefaul : true) {
        switch (e.key) {
          case ' ':
            if (e.target === _this.container.current || e.target === _this.progressBar.current) {
              e.preventDefault();
              _this.togglePlay(e);
            }
            break;
          case 'ArrowLeft':
            _this.handleClickRewind();
            break;
          case 'ArrowRight':
            _this.handleClickForward();
            break;
          case 'ArrowUp':
            e.preventDefault();
            _this.setJumpVolume(_this.props.volumeJumpStep);
            break;
          case 'ArrowDown':
            e.preventDefault();
            _this.setJumpVolume(-_this.props.volumeJumpStep);
            break;
          case 'l':
            _this.handleClickLoopButton();
            break;
          case 'm':
            _this.handleClickVolumeButton();
            break;
        }
      }
    };
    _this.renderUIModules = function (modules) {
      return modules.map(function (comp, i) {
        return _this.renderUIModule(comp, i);
      });
    };
    _this.renderUIModule = function (comp, key) {
      var _this$props3 = _this.props,
        _this$props3$defaultC = _this$props3.defaultCurrentTime,
        defaultCurrentTime = _this$props3$defaultC === void 0 ? '--:--' : _this$props3$defaultC,
        _this$props3$progress = _this$props3.progressUpdateInterval,
        progressUpdateInterval = _this$props3$progress === void 0 ? 20 : _this$props3$progress,
        _this$props3$showDown = _this$props3.showDownloadProgress,
        showDownloadProgress = _this$props3$showDown === void 0 ? true : _this$props3$showDown,
        _this$props3$showFill = _this$props3.showFilledProgress,
        showFilledProgress = _this$props3$showFill === void 0 ? true : _this$props3$showFill,
        _this$props3$showFill2 = _this$props3.showFilledVolume,
        showFilledVolume = _this$props3$showFill2 === void 0 ? false : _this$props3$showFill2,
        _this$props3$defaultD = _this$props3.defaultDuration,
        defaultDuration = _this$props3$defaultD === void 0 ? '--:--' : _this$props3$defaultD,
        _this$props3$customIc = _this$props3.customIcons,
        customIcons = _this$props3$customIc === void 0 ? {} : _this$props3$customIc,
        _this$props3$showSkip = _this$props3.showSkipControls,
        showSkipControls = _this$props3$showSkip === void 0 ? false : _this$props3$showSkip,
        onClickPrevious = _this$props3.onClickPrevious,
        onClickNext = _this$props3.onClickNext,
        onChangeCurrentTimeError = _this$props3.onChangeCurrentTimeError,
        _this$props3$showJump = _this$props3.showJumpControls,
        showJumpControls = _this$props3$showJump === void 0 ? true : _this$props3$showJump,
        _this$props3$customAd = _this$props3.customAdditionalControls,
        customAdditionalControls = _this$props3$customAd === void 0 ? [_constants.RHAP_UI.LOOP] : _this$props3$customAd,
        _this$props3$customVo = _this$props3.customVolumeControls,
        customVolumeControls = _this$props3$customVo === void 0 ? [_constants.RHAP_UI.VOLUME] : _this$props3$customVo,
        _this$props3$muted = _this$props3.muted,
        muted = _this$props3$muted === void 0 ? false : _this$props3$muted,
        _this$props3$timeForm = _this$props3.timeFormat,
        timeFormat = _this$props3$timeForm === void 0 ? 'auto' : _this$props3$timeForm,
        _this$props3$volume = _this$props3.volume,
        volumeProp = _this$props3$volume === void 0 ? 1 : _this$props3$volume,
        _this$props3$loop = _this$props3.loop,
        loopProp = _this$props3$loop === void 0 ? false : _this$props3$loop,
        mse = _this$props3.mse,
        _this$props3$i18nAria = _this$props3.i18nAriaLabels,
        i18nAriaLabels = _this$props3$i18nAria === void 0 ? H5AudioPlayer.defaultI18nAriaLabels : _this$props3$i18nAria;
      switch (comp) {
        case _constants.RHAP_UI.CURRENT_TIME:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: key,
            id: "rhap_current-time",
            className: "rhap_time rhap_current-time"
          }, /*#__PURE__*/_react.default.createElement(_CurrentTime.default, {
            audio: _this.audio.current,
            isLeftTime: false,
            defaultCurrentTime: defaultCurrentTime,
            timeFormat: timeFormat
          }));
        case _constants.RHAP_UI.CURRENT_LEFT_TIME:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: key,
            id: "rhap_current-left-time",
            className: "rhap_time rhap_current-left-time"
          }, /*#__PURE__*/_react.default.createElement(_CurrentTime.default, {
            audio: _this.audio.current,
            isLeftTime: true,
            defaultCurrentTime: defaultCurrentTime,
            timeFormat: timeFormat
          }));
        case _constants.RHAP_UI.PROGRESS_BAR:
          return /*#__PURE__*/_react.default.createElement(_ProgressBar.default, {
            key: key,
            ref: _this.progressBar,
            audio: _this.audio.current,
            progressUpdateInterval: progressUpdateInterval,
            showDownloadProgress: showDownloadProgress,
            showFilledProgress: showFilledProgress,
            onSeek: mse && mse.onSeek,
            onChangeCurrentTimeError: onChangeCurrentTimeError,
            srcDuration: mse && mse.srcDuration,
            i18nProgressBar: i18nAriaLabels.progressControl
          });
        case _constants.RHAP_UI.DURATION:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: key,
            className: "rhap_time rhap_total-time"
          }, mse && mse.srcDuration ? (0, _utils.getDisplayTimeBySeconds)(mse.srcDuration, mse.srcDuration, _this.props.timeFormat) : /*#__PURE__*/_react.default.createElement(_Duration.default, {
            audio: _this.audio.current,
            defaultDuration: defaultDuration,
            timeFormat: timeFormat
          }));
        case _constants.RHAP_UI.ADDITIONAL_CONTROLS:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: key,
            className: "rhap_additional-controls"
          }, _this.renderUIModules(customAdditionalControls));
        case _constants.RHAP_UI.MAIN_CONTROLS:
          {
            var isPlaying = _this.isPlaying();
            var actionIcon;
            if (isPlaying) {
              actionIcon = customIcons.pause ? customIcons.pause : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
                icon: "mdi:pause-circle"
              });
            } else {
              actionIcon = customIcons.play ? customIcons.play : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
                icon: "mdi:play-circle"
              });
            }
            return /*#__PURE__*/_react.default.createElement("div", {
              key: key,
              className: "rhap_main-controls"
            }, showSkipControls && /*#__PURE__*/_react.default.createElement("button", {
              "aria-label": i18nAriaLabels.previous,
              className: "rhap_button-clear rhap_main-controls-button rhap_skip-button",
              type: "button",
              onClick: onClickPrevious
            }, customIcons.previous ? customIcons.previous : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
              icon: "mdi:skip-previous"
            })), showJumpControls && /*#__PURE__*/_react.default.createElement("button", {
              "aria-label": i18nAriaLabels.rewind,
              className: "rhap_button-clear rhap_main-controls-button rhap_rewind-button",
              type: "button",
              onClick: _this.handleClickRewind
            }, customIcons.rewind ? customIcons.rewind : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
              icon: "mdi:rewind"
            })), /*#__PURE__*/_react.default.createElement("button", {
              "aria-label": isPlaying ? i18nAriaLabels.pause : i18nAriaLabels.play,
              className: "rhap_button-clear rhap_main-controls-button rhap_play-pause-button",
              type: "button",
              onClick: _this.togglePlay
            }, actionIcon), showJumpControls && /*#__PURE__*/_react.default.createElement("button", {
              "aria-label": i18nAriaLabels.forward,
              className: "rhap_button-clear rhap_main-controls-button rhap_forward-button",
              type: "button",
              onClick: _this.handleClickForward
            }, customIcons.forward ? customIcons.forward : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
              icon: "mdi:fast-forward"
            })), showSkipControls && /*#__PURE__*/_react.default.createElement("button", {
              "aria-label": i18nAriaLabels.next,
              className: "rhap_button-clear rhap_main-controls-button rhap_skip-button",
              type: "button",
              onClick: onClickNext
            }, customIcons.next ? customIcons.next : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
              icon: "mdi:skip-next"
            })));
          }
        case _constants.RHAP_UI.VOLUME_CONTROLS:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: key,
            className: "rhap_volume-controls"
          }, _this.renderUIModules(customVolumeControls));
        case _constants.RHAP_UI.LOOP:
          {
            var loop = _this.audio.current ? _this.audio.current.loop : loopProp;
            var loopIcon;
            if (loop) {
              loopIcon = customIcons.loop ? customIcons.loop : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
                icon: "mdi:repeat"
              });
            } else {
              loopIcon = customIcons.loopOff ? customIcons.loopOff : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
                icon: "mdi:repeat-off"
              });
            }
            return /*#__PURE__*/_react.default.createElement("button", {
              key: key,
              "aria-label": loop ? i18nAriaLabels.loop : i18nAriaLabels.loopOff,
              className: "rhap_button-clear rhap_repeat-button",
              type: "button",
              onClick: _this.handleClickLoopButton
            }, loopIcon);
          }
        case _constants.RHAP_UI.VOLUME:
          {
            var _ref = _this.audio.current || {},
              _ref$volume = _ref.volume,
              volume = _ref$volume === void 0 ? muted ? 0 : volumeProp : _ref$volume;
            var volumeIcon;
            if (volume) {
              volumeIcon = customIcons.volume ? customIcons.volume : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
                icon: "mdi:volume-high"
              });
            } else {
              volumeIcon = customIcons.volume ? customIcons.volumeMute : /*#__PURE__*/_react.default.createElement(_react2.Icon, {
                icon: "mdi:volume-mute"
              });
            }
            return /*#__PURE__*/_react.default.createElement("div", {
              key: key,
              className: "rhap_volume-container"
            }, /*#__PURE__*/_react.default.createElement("button", {
              "aria-label": volume ? i18nAriaLabels.volume : i18nAriaLabels.volumeMute,
              onClick: _this.handleClickVolumeButton,
              type: "button",
              className: "rhap_button-clear rhap_volume-button"
            }, volumeIcon), /*#__PURE__*/_react.default.createElement(_VolumeBar.default, {
              audio: _this.audio.current,
              volume: volume,
              onMuteChange: _this.handleMuteChange,
              showFilledVolume: showFilledVolume,
              i18nVolumeControl: i18nAriaLabels.volumeControl
            }));
          }
        default:
          if (! /*#__PURE__*/(0, _react.isValidElement)(comp)) {
            return null;
          }
          return comp.key ? comp : /*#__PURE__*/(0, _react.cloneElement)(comp, {
            key: key
          });
      }
    };
    return _this;
  }
  _inherits(H5AudioPlayer, _Component);
  return _createClass(H5AudioPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.forceUpdate();
      var audio = this.audio.current;
      if (this.props.muted) {
        audio.volume = 0;
      } else {
        audio.volume = this.lastVolume;
      }
      audio.addEventListener('error', function (e) {
        var target = e.target;
        if (target.error && target.currentTime === target.duration) {
          return _this2.props.onEnded && _this2.props.onEnded(e);
        }
        _this2.props.onError && _this2.props.onError(e);
      });
      audio.addEventListener('canplay', function (e) {
        _this2.props.onCanPlay && _this2.props.onCanPlay(e);
      });
      audio.addEventListener('canplaythrough', function (e) {
        _this2.props.onCanPlayThrough && _this2.props.onCanPlayThrough(e);
      });
      audio.addEventListener('play', this.handlePlay);
      audio.addEventListener('abort', this.handleAbort);
      audio.addEventListener('ended', this.handleEnded);
      audio.addEventListener('playing', function (e) {
        _this2.props.onPlaying && _this2.props.onPlaying(e);
      });
      audio.addEventListener('seeking', function (e) {
        _this2.props.onSeeking && _this2.props.onSeeking(e);
      });
      audio.addEventListener('seeked', function (e) {
        _this2.props.onSeeked && _this2.props.onSeeked(e);
      });
      audio.addEventListener('waiting', function (e) {
        _this2.props.onWaiting && _this2.props.onWaiting(e);
      });
      audio.addEventListener('emptied', function (e) {
        _this2.props.onEmptied && _this2.props.onEmptied(e);
      });
      audio.addEventListener('stalled', function (e) {
        _this2.props.onStalled && _this2.props.onStalled(e);
      });
      audio.addEventListener('suspend', function (e) {
        _this2.props.onSuspend && _this2.props.onSuspend(e);
      });
      audio.addEventListener('loadstart', function (e) {
        _this2.props.onLoadStart && _this2.props.onLoadStart(e);
      });
      audio.addEventListener('loadedmetadata', function (e) {
        _this2.props.onLoadedMetaData && _this2.props.onLoadedMetaData(e);
      });
      audio.addEventListener('loadeddata', function (e) {
        _this2.props.onLoadedData && _this2.props.onLoadedData(e);
      });
      audio.addEventListener('pause', this.handlePause);
      audio.addEventListener('timeupdate', (0, _utils.throttle)(function (e) {
        _this2.props.onListen && _this2.props.onListen(e);
      }, this.props.listenInterval));
      audio.addEventListener('volumechange', function (e) {
        _this2.props.onVolumeChange && _this2.props.onVolumeChange(e);
      });
      audio.addEventListener('encrypted', function (e) {
        var mse = _this2.props.mse;
        mse && mse.onEcrypted && mse.onEcrypted(e);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        src = _this$props4.src,
        autoPlayAfterSrcChange = _this$props4.autoPlayAfterSrcChange;
      if (prevProps.src !== src) {
        if (autoPlayAfterSrcChange) {
          this.playAudioPromise();
        } else {
          this.forceUpdate();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        _this$props5$classNam = _this$props5.className,
        className = _this$props5$classNam === void 0 ? '' : _this$props5$classNam,
        src = _this$props5.src,
        _this$props5$loop = _this$props5.loop,
        loopProp = _this$props5$loop === void 0 ? false : _this$props5$loop,
        _this$props5$preload = _this$props5.preload,
        preload = _this$props5$preload === void 0 ? 'auto' : _this$props5$preload,
        _this$props5$autoPlay = _this$props5.autoPlay,
        autoPlay = _this$props5$autoPlay === void 0 ? false : _this$props5$autoPlay,
        crossOrigin = _this$props5.crossOrigin,
        mediaGroup = _this$props5.mediaGroup,
        header = _this$props5.header,
        footer = _this$props5.footer,
        _this$props5$layout = _this$props5.layout,
        layout = _this$props5$layout === void 0 ? 'stacked' : _this$props5$layout,
        _this$props5$customPr = _this$props5.customProgressBarSection,
        customProgressBarSection = _this$props5$customPr === void 0 ? [_constants.RHAP_UI.CURRENT_TIME, _constants.RHAP_UI.PROGRESS_BAR, _constants.RHAP_UI.DURATION] : _this$props5$customPr,
        _this$props5$customCo = _this$props5.customControlsSection,
        customControlsSection = _this$props5$customCo === void 0 ? [_constants.RHAP_UI.ADDITIONAL_CONTROLS, _constants.RHAP_UI.MAIN_CONTROLS, _constants.RHAP_UI.VOLUME_CONTROLS] : _this$props5$customCo,
        children = _this$props5.children,
        style = _this$props5.style,
        _this$props5$i18nAria = _this$props5.i18nAriaLabels,
        i18nAriaLabels = _this$props5$i18nAria === void 0 ? H5AudioPlayer.defaultI18nAriaLabels : _this$props5$i18nAria;
      var loop = this.audio.current ? this.audio.current.loop : loopProp;
      var loopClass = loop ? 'rhap_loop--on' : 'rhap_loop--off';
      var isPlayingClass = this.isPlaying() ? 'rhap_play-status--playing' : 'rhap_play-status--paused';
      return /*#__PURE__*/_react.default.createElement("div", {
        role: "group",
        tabIndex: 0,
        "aria-label": i18nAriaLabels.player,
        className: "rhap_container ".concat(loopClass, " ").concat(isPlayingClass, " ").concat(className),
        onKeyDown: this.handleKeyDown,
        ref: this.container,
        style: style
      }, /*#__PURE__*/_react.default.createElement("audio", {
        src: src,
        controls: false,
        loop: loop,
        autoPlay: autoPlay,
        preload: preload,
        crossOrigin: crossOrigin,
        mediaGroup: mediaGroup,
        ref: this.audio
      }, children), header && /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_header"
      }, header), /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_main ".concat((0, _utils.getMainLayoutClassName)(layout))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_progress-section"
      }, this.renderUIModules(customProgressBarSection)), /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_controls-section"
      }, this.renderUIModules(customControlsSection))), footer && /*#__PURE__*/_react.default.createElement("div", {
        className: "rhap_footer"
      }, footer));
    }
  }]);
}(_react.Component);
H5AudioPlayer.defaultI18nAriaLabels = {
  player: 'Audio player',
  progressControl: 'Audio progress control',
  volumeControl: 'Volume control',
  play: 'Play',
  pause: 'Pause',
  rewind: 'Rewind',
  forward: 'Forward',
  previous: 'Previous',
  next: 'Skip',
  loop: 'Disable loop',
  loopOff: 'Enable loop',
  volume: 'Mute',
  volumeMute: 'Unmute'
};
var _default = exports.default = H5AudioPlayer;